import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak, { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import React, { FunctionComponent } from 'react';
import { assertDefinedOrReportProblem } from '../../utils';
import { App } from '../App/App';

export const AppKeycloakProvider: FunctionComponent = () => {
  const { config, initOptions } = createKeycloakConfiguration();
  const keycloak = new Keycloak(config);

  return <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={initOptions}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ReactKeycloakProvider>;
};

const createKeycloakConfiguration = (): { config: KeycloakConfig; initOptions: KeycloakInitOptions } => {
  assertDefinedOrReportProblem(process.env.REACT_APP_KEYCLOAK_REALM, 'Keycloak realm name');
  assertDefinedOrReportProblem(process.env.REACT_APP_KEYCLOAK_REALM, 'Keycloak URL');
  assertDefinedOrReportProblem(process.env.REACT_APP_KEYCLOAK_CLIENT_ID, 'Keycloak client ID');
  return {
    config: {
      realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
      url: process.env.REACT_APP_KEYCLOAK_URL,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
    },
    initOptions: {
      onLoad: 'login-required',
    },
  };
};
